export class AgentConfig {
    constructor(data) {
        this.agentId = data?.message?.agent_id;
        this.businessProductsAvailable = data?.message?.business_products_available;
        this.consumerProductsAvailable = data?.message?.consumer_products_available;
        this.returnsAvailableForAgent = data?.message?.return_available;
        // Voeg hier meer eigenschappen toe indien nodig
    }

    shouldShowBusinessEntity() {
        return !!this.businessProductsAvailable;
    }

    static async fetch(setIsFetchingData) {
        const agent = getAgentIdentifier(); 

        if (!agent) {
            console.error('No agent identifier found');
            setIsFetchingData(false);
            return null;
        }

        const BACKEND_URL = `${process.env.BACKEND_URL}/GetConfigForAgent`;
        const url = new URL(BACKEND_URL);
        const params = { agent: agent };
        url.search = new URLSearchParams(params).toString();

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.ok) {
                const data = await response.json();
                return new AgentConfig(data); // Create a new instance of AgentConfig
            } else {
                console.error('Error fetching agent configuration', response);
                return null;
            }
        } catch (error) {
            console.error('Error fetching agent configuration', error);
            return null;
        }
    }
}

export const getAgentIdentifier = () => {
    const scripts = document.getElementsByTagName('script');
    
    for (let script of scripts) {
        if (script.src.includes('aanmeldstraat.js')) {
            const url = new URL(script.src);
            const agent = url.searchParams.get('agent');
            return agent;
        }
    }

    return null;
};